<template lang="pug">
el-collapse#card-dados-territorio(v-model='collapse')
    el-collapse-item.pb-0(name='item')
        header.p-2(slot='title')
            .esquerda
                span {{ index + 1 }}
                h3 {{ territorio.nome }}
                span.erro(v-if='$v.dados.$invalid') *

            .direita
                h3.mr-2.p-1 {{ territorio.localidade }}
                BaseButton.buttonLaudoDanger(
                    type='danger',
                    icon='el-icon-delete',
                    @click='$emit("removerTerritorio", territorio.id)'
                )

        el-form.form.p-2(label-position='top', size='small')
            el-form-item.produtor
                .label(slot='label')
                    span {{ $t('mensagens.laudos.pessoaS') }}
                    span(v-show='this.territorio.representantes.length === 0') - {{ $t('mensagens.laudos.nenhumaPessoaVinculada') }}
                el-checkbox-group(
                    v-model='representanteSelecionado',
                    size='mini',
                    @change='emiteDados'
                )
                    el-checkbox(
                        v-for='(representante, index) in territorio.representantes',
                        :label='representante',
                        :key='index'
                    )
                        | {{ representante.nomeRazaoSocial }} ({{ numeralStringFormatTocpfCnpj(representante.cpfCnpj) }})
                        span.espacoRepresentante

                .outro
                    el-checkbox(
                        v-model='representanteSelecionadoNovo',
                        :label='outroRepresentante'
                    ) {{ $t('mensagens.laudos.outro') }}:
                    .input(v-if='representanteSelecionadoNovo')
                        el-input.nome(
                            v-model='outro.nome',
                            @change='emiteDados',
                            :class='{ "erro-borda": !nomeValido }',
                            :placeholder="$t('mensagens.laudos.insiraNomeOuRazaoSocialDaPessoa')"
                        )

                        el-input.cpfCnpj(
                            v-model='outro.cpfCnpj',
                            @change='emiteDados',
                            :placeholder="$t('mensagens.laudos.documentoDaPessoa')",
                            :class='{ "erro-borda": !cpfCnpjValido }'
                        )

                    .input(v-else)
                        el-input.nome(
                            disabled,
                            :placeholder="$t('mensagens.laudos.insiraNomeOuRazaoSocialDaPessoa')"
                        )
                        el-input.cpfCnpj(
                            disabled,
                            :placeholder="$t('mensagens.laudos.documentoDaPessoa')",
                        )

            .dados
                p.selecione-car-laudo {{ $t('mensagens.laudos.selecioneAbaixoOCarVinculadoAoTerritorioParaQualDesejaLaudo') }}
                el-form-item
                    el-radio-group.cars-radio-dados(
                        v-model='carSelecionado',
                        size='mini',
                        @change='emiteDados'
                    )
                        el-radio(
                            v-for='(car, index) in getCars',
                            :label='car.id',
                            :key='index'
                        ) {{ car.codigo }}
                p.text-car {{ $t('mensagens.laudos.casoCarDesejadoNaoEstejaNaListagem') }}
</template>

<script>
import formatters from '@/utils/formatters';
import validators from '@/utils/validators';
import { required } from 'vuelidate/lib/validators';
import TipoLaudo from '@/constants/TipoLaudo';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

const OUTRO_REPRESENTANTE = '42';

export default {
    name: 'CardDadosTerritorioBacenResolucao140',

    components: {
        BaseButton
    },

    emits: ['removerTerritorio', 'getDados', 'getValidacao'],

    props: {
        territorio: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        valido: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            collapse: ['item'],
            carSelecionado: null,
            limite: 50,
            representanteSelecionado: [],
            representanteSelecionadoNovo: false,

            outro: {
                nome: '',
                cpfCnpj: ''
            },

            outroRepresentante: OUTRO_REPRESENTANTE,

            datas: {
                plantio: null,
                colheita: null
            },
            nomeRepresentante: '',
            cpfCnpjRepresentante: '',
            tipoLaudoId: '',

            cpfCnpjValido: true,
            nomeValido: true
        };
    },
    mounted() {
        if (this.territorio.representantes.length === 0) {
            this.representanteSelecionadoNovo = true;
        }
        this.$emit('getValidacao', {
            valido: !this.$v.dados.$invalid,
            id: this.territorio.id
        });
    },
    computed: {
        getCars: function () {
            if (!this.territorio.cars) return;
            return this.limite
                ? this.territorio.cars.slice(0, this.limite)
                : this.territorio.cars;
        }
    },
    watch: {
        'outro.nome': function () {
            if (this.outro.nome === '') {
                this.nomeValido = false;
            } else {
                this.nomeValido = true;
            }
            this.nomeRepresentante = this.outro.nome;
        },

        'outro.cpfCnpj': function () {
            this.cpfCnpjValido = validators.validarDocumento(this.outro.cpfCnpj);

            if (this.cpfCnpjValido) {
                this.cpfCnpjRepresentante = this.outro.cpfCnpj;
            } else {
                this.cpfCnpjRepresentante = '';
            }
        },

        representanteSelecionadoNovo: function () {
            this.emiteDados();
        }
    },

    validations: {
        carSelecionado: { required },

        dados: ['carSelecionado']
    },

    methods: {
        emiteDados() {
            this.outro.cpfCnpj = formatters.documentoFormatToNumeral(this.outro.cpfCnpj);
            this.outro.cpfCnpj = formatters.numeralStringFormatToDocumento(this.outro.cpfCnpj);

            let isClienteNovo = null;
            if (
                this.representanteSelecionadoNovo &&
                this.nomeRepresentante !== '' &&
                this.cpfCnpjRepresentante !== ''
            ) {
                isClienteNovo = {
                    nomeRepresentante: this.nomeRepresentante,
                    cpfCnpjRepresentante: this.cpfCnpjFormatToNumeral(
                        this.cpfCnpjRepresentante
                    ),
                    tipoDocumentoRepresentante: this.cpfCnpjRepresentante.length < 11 ? 'RUC' : 'CPF_CNPJ'
                };
            } else {
                isClienteNovo = null;
            }

            this.$emit('getValidacao', {
                valido: !this.$v.dados.$invalid,
                id: this.territorio.id
            });

            if (this.representanteSelecionado) {
                this.representanteSelecionado.forEach(rep => {
                    rep.tipoDocumentoRepresentante = rep.cpfCnpj.length < 11 ? 'RUC' : 'CPF_CNPJ';
                });
            }

            this.$emit('getDados', {
                dados: {
                    representantes: this.representanteSelecionado,
                    carId: this.carSelecionado,
                    clienteNovo: isClienteNovo,
                    territorioId: this.territorio.id,
                    tipoLaudoId: TipoLaudo.BACEN_140
                },
                id: this.territorio.id
            });
        },
        numeralStringFormatTocpfCnpj(value) {
            return formatters.numeralStringFormatToDocumento(value);
        },

        cpfCnpjFormatToNumeral(value) {
            return formatters.documentoFormatToNumeral(value);
        }
    }
};
</script>

<style lang="scss" scoped>
#card-dados-territorio {
    background-color: var(--white);
    border-radius: 4px;
    overflow: hidden;
    width: 100% !important;

    header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0 !important;

        .esquerda,
        .direita {
            display: flex;
            align-items: center;
            justify-content: space-between;

            gap: 4px;
        }

        .esquerda {
            span {
                color: var(--gray);
                font-size: 12px;
            }
        }

        .direita {
            h3 {
                background-color: var(--default-border-color);
                border-radius: 4px;
            }
        }
    }

    .form {
        .produtor .outro .input {
            display: flex;
            justify-content: space-between;

            .nome {
                width: 66%;
            }

            .cpfCnpj {
                width: 33%;
            }
        }

        .dados {
            display: flex;
            flex-direction: column;
            gap: 8px;
            width: 100% !important;

            .el-input,
            .el-select,
            .el-date-picker {
                width: 150px;
            }
        }
        .el-radio {
            min-width: 379px !important;
        }
    }
}

.el-collapse-item__arrow {
    width: 0px;
    color: var(--white);
}

.el-form-item__label {
    margin-bottom: -10px;
}

.el-collapse-item__content {
    padding-bottom: 0px;
}

.erro {
    color: red !important;
}

.erro-borda {
    border-radius: 4px;
    border: 1px solid red;
}
.cars-radio-dados {
    display: flex;
    flex-wrap: wrap;
    max-height: 180px;
    flex-direction: column;
}
.selecione-car-laudo {
    font-size: 15px;
    font-weight: 400;
    color: #656266;
}
</style>
